import { render } from "./VisionVentureLayout.vue?vue&type=template&id=ff8dc45e&scoped=true"
import script from "./VisionVentureLayout.vue?vue&type=script&lang=js"
export * from "./VisionVentureLayout.vue?vue&type=script&lang=js"

import "./VisionVentureLayout.vue?vue&type=style&index=0&id=ff8dc45e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8dc45e"]])

export default __exports__